import React from "react"
import { graphql } from "gatsby"
import { Link } from "gatsby"
import Image from "gatsby-image"
import { MDXRenderer } from "gatsby-plugin-mdx"
import Layout from "../components/Layout"
import styles from "../css/postTemplate.module.css"
import { ThemeProvider } from "../context/ThemeContext"
import Bio from "../components/Bio"
import SEO from "../components/SEO"
import Switch from "../components/Switch"
import { Helmet } from "react-helmet"
import Social from "../components/Social"
import { DiscussionEmbed } from "disqus-react"
// import AniLink from "gatsby-plugin-transition-link/AniLink";

export default function PostTemplate({ data, pageContext }) {
  const { title, date, image, slug, spoiler } = data.mdx.frontmatter
  const customTitle = `${title} | SiamWrites`
  const { body, timeToRead } = data.mdx
  const { next, prev } = pageContext
  const img = image.childImageSharp.fluid
  const time = Math.ceil(timeToRead * 1.75)
  const siteUrl = `https://siamwrites.netlify.app/`

  const disqusConfig = {
    shortname: 'SiamWrites',
    config: { identifier: slug, title },
  }

  return (
    <>
      <SEO
        title={customTitle}
        description={spoiler}
        image={image.childImageSharp.fluid.srcWebp}
        pathname={`${siteUrl}${slug}/`}
        article={true}
      />
      <Helmet>
        <html lang="en" />
      </Helmet>
      <ThemeProvider>
        <Layout>
          <section className={styles.template}>
            <div className={styles.navbar}>
              <Link to="/">
                <h1 id={styles.navlink}>SiamWrites</h1>
              </Link>

              <Switch />
            </div>

            <div className={styles.container}>
              <div className={styles.info}>
                <h1>{title}</h1>
                <h4>
                  <span>
                    <span role="img" aria-label="coffee-emoji">
                      📅
                    </span>{" "}
                    {date}
                  </span>
                  <span className={styles.period}>&#8901;</span>
                  <span>
                    <span role="img" aria-label="coffee-emoji">
                      ☕
                    </span>{" "}
                    {time} min read
                  </span>
                </h4>
              </div>

              <div className={styles.bgimage}>
                <Image fluid={img} />
              </div>

              <div className={styles.content}>
                <MDXRenderer>{body}</MDXRenderer>
              </div>
            </div>
          </section>

          <div className={styles.center}>
            <div className={styles.center}>
              <DiscussionEmbed {...disqusConfig} />
            </div>

            <hr className={styles.divider}></hr>

            <div className={styles.center}>
              <Link to="/">
                <h1 id={styles.navlink}>SiamWrites</h1>
              </Link>
              <Bio />

              <div className={styles.footerPost}>
                {prev && (
                  <Link to={`${prev.frontmatter.slug}/`}>
                    <h3
                      className={styles.footerPostLink}
                      style={{ marginLeft: "1rem" }}
                    >
                      ← {prev.frontmatter.title}
                    </h3>
                  </Link>
                )}
                {next && (
                  <Link to={`${next.frontmatter.slug}/`}>
                    <h3 className={styles.footerPostLink}>
                      {next.frontmatter.title} →
                  </h3>
                  </Link>
                )}
              </div>
            </div>

            <hr className={styles.divider}></hr>

            <Social />
            <div className={styles.mb} />
          </div>
        </Layout>
      </ThemeProvider>
    </>
  )
}

export const query = graphql`
  query getPost($slug: String!) {
    mdx(frontmatter: { slug: { eq: $slug } }) {
      frontmatter {
        title
        slug
        spoiler
        date(formatString: "MMMM Do, YYYY")
        image {
          base
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      timeToRead
      body
    }
  }
`
